var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiAmarelo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3554_24339)",
    filter: "url(#filter0_ii_3554_24339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5967 18.4565C31.5067 10.3955 26.5203 2.31229 18.4592 0.402276C10.3981 -1.50774 2.31494 3.47868 0.404922 11.5398C-1.50509 19.6008 3.48133 27.684 11.5424 29.594C19.6035 31.504 27.6867 26.5176 29.5967 18.4565Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8448 19.6511H8.15492C7.74942 19.6511 7.42017 19.3219 7.42017 18.9164C7.42017 18.5109 7.74942 18.1816 8.15492 18.1816H21.8448C22.2503 18.1816 22.5796 18.5109 22.5796 18.9164C22.5796 19.3219 22.2503 19.6511 21.8448 19.6511Z",
    fill: "#562912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8467 12.4457C22.8467 13.3191 22.1397 14.0296 21.2628 14.0296C20.386 14.0296 19.679 13.3191 19.679 12.4457C19.679 11.5723 20.3894 10.8618 21.2628 10.8618C22.1362 10.8618 22.8467 11.5723 22.8467 12.4457Z",
    fill: "#562912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3176 12.4457C10.3176 13.3191 9.60716 14.0296 8.73378 14.0296C7.86039 14.0296 7.1499 13.3191 7.1499 12.4457C7.1499 11.5723 7.86039 10.8618 8.73378 10.8618C9.60716 10.8618 10.3176 11.5723 10.3176 12.4457Z",
    fill: "#562912"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_3554_24339",
    x: -2,
    y: -2,
    width: 35,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.968627 0 0 0 0 0.835294 0 0 0 0 0.435294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3554_24339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.616667 0 0 0 0 0.434655 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3554_24339",
    result: "effect2_innerShadow_3554_24339"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3554_24339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiAmarelo);
export default __webpack_public_path__ + "static/media/emoji_amarelo.ebda9492ab91dfe6845243bbedad7880.svg";
export { ForwardRef as ReactComponent };